import { render } from "./GenericDataTable2.vue?vue&type=template&id=837be45e&scoped=true"
import script from "./GenericDataTable2.vue?vue&type=script&lang=js"
export * from "./GenericDataTable2.vue?vue&type=script&lang=js"

import "./GenericDataTable2.vue?vue&type=style&index=0&id=837be45e&scoped=true&lang=css"
import "./GenericDataTable2.vue?vue&type=style&index=1&id=837be45e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837be45e"]])

export default __exports__